module.exports = __webpack_public_path__ + "img/zs10.45642845.png";